export const CHATS_PATH = '/chats'

export const chatPath = ({ chatId }: { chatId?: string } = {}) => {
  return chatId ? `${CHATS_PATH}/${chatId}` : CHATS_PATH
}

export const isChattingPage = () =>
  // [/?] : /chats?chatId=123123 or /chats/123123 path 확인
  typeof global.location !== 'undefined' && /\/chats[/?].+/.test(location.href)
